export const SUBMIT_ERROR_TEXT =
  'Ошибка. Попробуйте еще раз и обратитесь в службу поддержки, если ошибка повторится.';
export const VACATION_START_ATTR_ID = '74d035bd-cac8-4405-a54a-021dc9f986f7';
export const VACATION_END_ATTR_ID = '832839ab-6865-4e2d-89c4-bd3aaab2c749';
export const VACATION_TYPE_ATTR_ID = '60fbfa41-496e-4de3-ac60-44e422036ef9';
export const ALLOW_COMPENSATION_ATTR_ID =
  '8a7b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d';
export const VACATION_EMPLOYEE_COMMENT_ATTR_ID =
  '41d862d6-97a9-431d-aca6-dcc00a2a1899';
export const VACATION_COMPANY_COMMENT_ATTR_ID =
  '67396f15-d69c-401f-8469-d1454fbb4ad4';

export const VACATION_ERROR_MESSAGES: Record<string, string> = {
  '14_days_error':
    'Хотя бы один отпуск должен быть не менее 14 календарных дней',
  min_specific_weekend_days_error:
    'Один или несколько периодов отпуска не включает необходимое минимальное количество выходных дней',
  vacation_min_5_days_between_not_workdays_error:
    'Один или несколько периодов отпуска включают в себя отпуск менее 5 дней между выходными и праздничными днями',
};

export const OPTIONS_HIDE_THRESHOLD = 2;
